import React, { Component } from 'react';
import styles from './questionAnswers.css';
import Slider from 'components/common/customRCSlider/src';
import { Range } from 'components/common/customRCSlider/src';
import 'assets/css/scale.css';
import { connect } from 'react-redux';
import { getFontFamily, getSwitchClassNameOrColourWithBackground } from 'utils/func';

const mapStateToProps = ( { localization: { content }, calendar } ) => ( { content, calendar } );

@connect( mapStateToProps )
class QuestionAnswers extends Component {

    constructor( props ) {
        super( props );

        this.state = {
            id: 0,
            user_answer: null,
            type: '',
            answered: false,
            isAnswered: false,
            answerStyle: '',
            valueStringLenght: 4
        };

        this.range = {
            min: 0,
            max: 0
        };

        this.point = 0;
    };

    getColor = () => {
        const { calendar: { settings: { appearance } } } = this.props;
        return getSwitchClassNameOrColourWithBackground( appearance.background_color, 'rgba(0,0,0,0.7)', 'rgba(250,250,250,0.8)' );
    };

    /**
     *
     * @param size
     * @param length
     * @param endVal
     * @param lengthInterval
     * @param endFlag
     * @returns {{fontFamily: ({fontFamily: string, color: string, fontFamilyH2: string, fontFamilyH1: string}|{fontFamily: string, color: string, fontFamilyH2: string, fontFamilyH1: string}|{fontFamily: string, color: string, fontFamilyH2: string, fontFamilyH1: string}|{fontFamily: string, color: string, fontFamilyH2: string, fontFamilyH1: string}), color: string, fontSize: string, fontWeight: string, textTransform: string, marginLeft: string}|{fontFamily: string, color: *, top: string, paddingRight: string, fontSize: string, fontWeight: string, marginLeft: (string)}|{fontFamily: ({fontFamily: string, color: string, fontFamilyH2: string, fontFamilyH1: string}|{fontFamily: string, color: string, fontFamilyH2: string, fontFamilyH1: string}|{fontFamily: string, color: string, fontFamilyH2: string, fontFamilyH1: string}|{fontFamily: string, color: string, fontFamilyH2: string, fontFamilyH1: string}), color: string, top: string, paddingRight: string, fontSize: string, fontWeight: string, marginLeft: (string)}|{fontFamily: ({fontFamily: string, color: string, fontFamilyH2: string, fontFamilyH1: string}|{fontFamily: string, color: string, fontFamilyH2: string, fontFamilyH1: string}|{fontFamily: string, color: string, fontFamilyH2: string, fontFamilyH1: string}|{fontFamily: string, color: string, fontFamilyH2: string, fontFamilyH1: string}), color: string, top: string, paddingRight: string, fontSize: string, textTransform: string}|{transform: string, fontFamily: ({fontFamily: string, color: string, fontFamilyH2: string, fontFamilyH1: string}|{fontFamily: string, color: string, fontFamilyH2: string, fontFamilyH1: string}|{fontFamily: string, color: string, fontFamilyH2: string, fontFamilyH1: string}|{fontFamily: string, color: string, fontFamilyH2: string, fontFamilyH1: string}), color: string, top: string, paddingRight: string, fontSize: string}|{fontFamily: ({fontFamily: string, color: string, fontFamilyH2: string, fontFamilyH1: string}|{fontFamily: string, color: string, fontFamilyH2: string, fontFamilyH1: string}|{fontFamily: string, color: string, fontFamilyH2: string, fontFamilyH1: string}|{fontFamily: string, color: string, fontFamilyH2: string, fontFamilyH1: string}), color: string, top: string, paddingRight: string, fontSize: string, fontWeight: string}}
     */
    setRangeStyle = ( size, length, endVal, lengthInterval, endFlag ) => {
        const { calendar: { settings } } = this.props;
        const fontFamily = getFontFamily( settings?.appearance?.font_style ).defaultFont;
        const textColor = this.getColor();
        let valStr = String( endVal );
        let lengthStr = valStr.length;

        if ( size === 'desk' ) {
            if ( lengthStr > 2 && lengthInterval > 5 ) {
                return {
                    fontFamily: fontFamily,
                    color: '#fff',
                    fontSize: '2.5rem',
                    top: '-7rem',
                    paddingRight: '2px'

                };

            } else {
                return {
                    fontFamily: fontFamily,
                    color:  '#fff',
                    fontSize: '3rem',
                    textTransform: 'uppercase',
                    top: '-7rem',
                    paddingRight: '2px'
                };
            }
        }

        if ( size === 'mob' ) {
            if ( lengthStr > 2 && lengthInterval > 5 ) {
                return {
                    fontFamily: fontFamily,
                    color:  '#fff',
                    fontSize: '3rem',
                    textTransform: 'uppercase',
                    fontWeight: 'bold',
                    marginLeft: '5rem',
                };
            } else {
                return {
                    fontFamily: fontFamily,
                    color:  '#fff',
                    fontSize: '3rem',
                    textTransform: 'uppercase',
                    fontWeight: 'bold',
                    marginLeft: '5rem',
                };
            }
        }

        if ( size === 'mob2' ) {
            let pText = endVal.toString();
            let pLength = pText.length;

            if ( pLength <= 2 ) {
                return {
                    fontFamily: fontFamily,
                    color: '#fff',
                    fontSize: '3.5rem',
                    top: '3.5rem',
                    paddingRight: '2px',
                    fontWeight: 'bold'
                };
            } else if ( pLength > 2 && pLength <= 4 ) {
                return {
                    fontFamily: fontFamily,
                    color:  '#fff',
                    width:'auto',
                    fontSize: '3rem',
                    top: '3.5rem',
                    paddingRight: '2px',
                    marginLeft: endFlag ? '-6rem' : '0',
                };
            } else if ( pLength > 4 && pLength <= 7 ) {
                return {
                    fontFamily: fontFamily,
                    color:  '#fff',
                    fontSize: '2.3rem',
                    top: '3.5rem',
                    paddingRight: '2px',
                    width:'auto',
                    marginLeft: endFlag ? '-7rem' : '0',
                };
            } else {
                return {
                    fontFamily: fontFamily,
                    color:  '#fff',
                    fontSize: '1.6 rem',
                    textTransform: 'uppercase',
                    paddingRight: '2px',
                    fontWeight: 'bold',
                    top: '3.5rem',
                    marginLeft: endFlag ? '-5rem' : '-2rem',
                };
            }

        }

    };

    seToolTipStyle = () => {
        const windowSize = window.innerWidth > 420;
        const stylePrefix = this.state.valueStringLenght < 5 ? 'rc-slider-tooltip2' : 'rc-slider-tooltip2small';
        return windowSize ?
            {
                placement: 'bottom',
                prefixCls: stylePrefix,
            } :
            {
                placement: 'top',
                prefixCls: stylePrefix,
            };

    };


    tollTipHidden = () => {
        return {
            prefixCls: 'rc-slider-tooltip2-hidden'
        };
    };

    setSound = () => this.props.setEventSound( { events: 'hover' } );

    /**
     *
     * @param pointInterval
     * @param length
     * @param stepInt
     */
    getLengthInterval = ( pointInterval, length, stepInt ) => {

        if ( pointInterval > 15 ) {
            if ( ( ( length / 10 ) ^ 0 ) === ( length / 10 ) ) {
                return ( length / 10 );
            }

            if ( ( ( length / 11 ) ^ 0 ) === ( length / 11 ) ) {
                return ( length / 11 );
            }

            if ( ( ( length / 12 ) ^ 0 ) === ( length / 12 ) ) {
                return ( length / 12 );
            }

            if ( ( ( length / 13 ) ^ 0 ) === ( length / 13 ) ) {
                return ( length / 13 );
            }

            if ( ( ( length / 14 ) ^ 0 ) === ( length / 14 ) ) {
                return ( length / 14 );
            }

            if ( ( ( length / 15 ) ^ 0 ) === ( length / 15 ) ) {
                return ( length / 15 );
            }

            if ( ( ( length / 16 ) ^ 0 ) === ( length / 16 ) ) {
                return ( length / 16 );
            }

            if ( ( ( length / 17 ) ^ 0 ) === ( length / 17 ) ) {
                return ( length / 17 );

            } else {
                return ( length / 19 );
            }

        } else {
            return stepInt;
        }
    }


    getStepsSpans = () => {
        const { answer } = this.props;
        const endInterval = Number( answer.end_value );
        const startInterval = Number( answer.start_value );
        const stepInt = ( Number( answer.step_interval ) > 0 ) ? Number( answer.step_interval ) : 1;
        const length = startInterval < endInterval
            ? ( endInterval - startInterval )
            : ( startInterval - endInterval );

        const pointInterval = length / stepInt;
        const lengthInterval = this.getLengthInterval( pointInterval, length, stepInt );
        const lengPie = Math.round( length / lengthInterval );

        const windowSize = window.innerWidth > 420;

        let scaleObj = {};
        let c = 0;

        for ( let i = startInterval ; i <= endInterval ; i = i + lengthInterval ) {

            const getLabel = ( i ) => {
                if ( windowSize ) {
                    return Math.round( i );
                } else {
                    if ( c === 0 ) return Math.round( i );
                    if ( Math.round( i ) >= endInterval ) return endInterval;
                }
            };
            let endFlag = ( Math.round( i ) >= endInterval );

            scaleObj[ Math.round( i ) ] = {
                style: windowSize ?
                    this.setRangeStyle( 'desk', length, endInterval, lengPie, endFlag ) :
                    this.setRangeStyle( 'mob2', length, endInterval, lengPie, endFlag ),
                label: getLabel( i )
            };
            c++;
        }

        return scaleObj;
    };

    componentDidUpdate( prevProps ) {
        if ( JSON.stringify( prevProps.statistics ) !== JSON.stringify( this.props.statistics ) ) {
            const { statistics } = this.props;
            if ( this.props.statistics !== null && statistics?.question_statistics?.answered_correctly ) {
                this.setState( {
                    answered: true,
                    answerStyle: '#7ed321'
                } );
            } else {
                this.setState( {
                    answered: true,
                    answerStyle: 'rgba(230, 106, 29, 1)'
                } );
            }
        }
        if ( this.props.question.id !== prevProps.question.id ) {
            this.setState( { answered: false, isAnswered: false } );
        }
    }

    componentDidMount() {
        const { question, answer } = this.props;
        const { localization } = question;
        const valueStringLenght = String( answer.end_value ).length;
        window.onresize = () => {
            this.forceUpdate();
        };

        this.setState( {
            id: answer.id,
            user_answer: JSON.stringify( {
                ...{
                    valueStringLenght,
                    min: Number( answer.start_value ),
                    max: Number( answer.end_value )
                }
            } ),
            type: localization.answer_model
        }, () => {
            this.range = {
                min: Number( answer.start_value ),
                max: Number( answer.end_value )
            };
        } );

        if ( answer.answer_type === 'point' ) {
            const isDouble = Number( answer.end_value ) % 2 === 0;
            this.point = isDouble ? ( Number( answer.start_value ) +
                ( ( Number( answer.end_value ) - Number( answer.start_value ) ) / 2 ) ) :
                Math.floor( ( Number( answer.start_value ) + ( ( Number( answer.end_value ) - Number( answer.start_value ) ) / 2 ) ) );

        } else {

            this.range = {
                min: Number( answer.start_value ),
                max: Number( answer.start_value )
            };
        }
    };

    render() {
        const { question, answer, content, statisticsPopup,  statistics, handleAnswerSelection, calendar: { settings }, contentColor } = this.props;
        const { localization } = question;
        const createSliderWithTooltip = Slider.createSliderWithTooltip;
        const SliderWithTooltip = createSliderWithTooltip( Slider );
        const Range = createSliderWithTooltip( Slider.Range );
        const windowSize = window.innerWidth > 420;
        const defaultFont = getFontFamily( settings?.appearance?.font_style ).defaultFont;
        const hoverColor = { 'filter': 'invert(30%)' };
        const isImagePositionCover = question.localization.image_position === 'cover';
        return (
            <div className={ styles.wrapper }>
                <div
                    className={ isImagePositionCover ? styles.wrapperStyleHorizontalWrapper : styles.wrapperStyleHorizontalWrapperNotCover }>
                    <div onBlur={ () => {
                        this.state.id = answer.id;
                        this.state.type = localization.answer_model;
                    } } className={ styles.wrapperStyleHorizontal }>

                        { windowSize ||
                        <p className={ this.state.valueStringLenght < 5 ? styles.valueStyle : styles.valueStyleLong }>{ answer.value }</p> }
                        <div className='calendarRangePlayer'>
                            { ( answer.answer_type === 'point' ) ?

                                <SliderWithTooltip
                                    fontStyle={ settings.appearance && ( Slider.tooltipFont = defaultFont ) }
                                    contentColor={ contentColor }
                                    allowCross={ false }
                                    changeprocstylestatic={ hoverColor }
                                    changeprocstyleactive={ { backgroundColor: settings.appearance && `${ settings.appearance.highlight_color }` } }
                                    included={ true }
                                    marks={ this.getStepsSpans() }
                                    min={ Number( answer.start_value ) }
                                    max={ Number( answer.end_value ) }
                                    step={ Number( answer.step_interval ) }
                                    defaultValue={ this.point }
                                    tipProps={ (statisticsPopup && statistics)? this.tollTipHidden() :this.seToolTipStyle() }
                                    handleStyle={ { backgroundColor: this.state.answered ? this.state.answerStyle : settings?.appearance?.highlight_color } }
                                    trackStyle={ { backgroundColor: this.state.answered ? this.state.answerStyle : settings?.appearance?.highlight_color } }
                                    dotStyle={ { backgroundColor: '#e9e9e9' } }
                                    onChange={ value => {
                                        this.point = value;
                                        this.state.user_answer = value;
                                    } }
                                /> :


                                <Range
                                    fontStyle={ settings.appearance && ( Slider.tooltipFont = defaultFont ) }
                                    contentColor={ contentColor }
                                    allowCross={ false }
                                    changeprocstylestatic={ { backgroundColor: '#fff' } }
                                    changeprocstyleactive={ { backgroundColor: settings.appearance && `${ settings.appearance.highlight_color }` } }
                                    trackStyle={ { backgroundColor: settings.appearance && settings.appearance.highlight_color } }
                                    included={ windowSize ? false : true }
                                    marks={ this.getStepsSpans() }
                                    min={ Number( answer.start_value ) }
                                    max={ Number( answer.end_value ) }
                                    step={ Number( answer.step_interval ) }
                                    defaultValue={ answer.answer_type === 'point' ? [ this.point ] : [ this.range.min, this.range.max ] }
                                    tipProps={ (statisticsPopup && statistics)? this.tollTipHidden() :this.seToolTipStyle()  }
                                    handleStyle={ [ { backgroundColor: windowSize ? '#fff' : settings.appearance && `${ settings.appearance.highlight_color }` } ] }
                                    dotStyle={ { backgroundColor: '#e9e9e9' } }
                                    onChange={ value => {
                                        this.range = {
                                            min: value[ 0 ],
                                            max: value[ 1 ]
                                        };

                                        this.state.user_answer = JSON.stringify( {
                                            ...{
                                                min: value[ 0 ],
                                                max: value[ 1 ]
                                            }
                                        } );
                                    } }
                                /> }
                        </div>
                        { windowSize && <p className={ styles.valueStyle }>{ answer.value }</p> }

                    </div>
                </div>
                <div className={ styles.submitWrap }>
                    <div
                        onMouseEnter={ this.setSound }
                        style={ settings && { ...settings.appearance.button_style } }
                        className={ styles.submit }
                        aria-label={ content.calendar.submit_aria_label }
                        onClick={ () => {
                            if ( this.state.isAnswered === false ) {
                                handleAnswerSelection( { question_localization_id: localization.id, ...this.state } )
                                this.setState( { isAnswered: true } );
                            }
                        }
                        }
                    >
                        { content.calendar.submit }
                    </div>
                </div>

            </div>
        );
    };
}

export default QuestionAnswers;
